<template>
  <v-app>
    <v-container id="layout-content-only" fluid fill-height pt-0 pl-0 pr-0 pb-0>
      <v-row>
        <v-col
          md8
          lg9
          class="hidden-sm-and-down bg"
          v-bind:class="{ 'bg-bn': !isProduction }"
        ></v-col>
        <v-col md4 lg3>
          <v-main>
            <v-container fluid fill-height>
              <router-view></router-view>
            </v-container>
          </v-main>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
"use strict";

export default {
  computed: {
    isProduction() {
      return process.env.NODE_ENV == "production";
    }
  }
};
</script>

<style lang="scss">
#layout-content-only {
  .bg {
    background-image: url("~@/assets/images/backgrounds/layout-bg.png");
    background-size: cover;
  }

  .bg-bn {
    background-image: url("~@/assets/images/backgrounds/layout-bg-bn.png");
  }
}
</style>
